import { QueryClient } from '@tanstack/react-query';
import { SystemPermission_Permission } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { getSystemQuery } from '~/shared/api/system.queries';
import { listSystemDesignAlertsQuery } from '~/shared/api/systemDesignAlerts.queries';
import {
  checkAuthorization,
  checkIfUserHasPermissionForSystem,
} from '~/shared/auth/auth-utils';
import { createSystemRoute } from '~/shared/models/create-routes';
import { SystemModel } from '~/shared/models/system/SystemModel';
import { assertIsDefined } from '~/types/assert-type';

export const systemDesignLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    await checkAuthorization(queryClient, request);

    const { systemId } = params;
    assertIsDefined(systemId);

    const userHasDesignPermissions = await checkIfUserHasPermissionForSystem(
      queryClient,
      request,
      systemId,
      [
        SystemPermission_Permission.DESIGN,
        SystemPermission_Permission.COMMISSIONING,
      ],
    );

    const system = await queryClient.ensureQueryData(getSystemQuery(systemId));

    const systemModel = new SystemModel({ system });

    assertIsDefined(system);

    const systemNotInDesignPhase =
      systemModel.state !== 'CONFIGURATION' &&
      systemModel.state !== 'PRODUCTION_EDIT' &&
      systemModel.state !== 'ADVICE';

    if (systemNotInDesignPhase || !userHasDesignPermissions) {
      return redirect(createSystemRoute(systemModel.id));
    }

    const systemDesignAlerts = await queryClient.ensureQueryData(
      listSystemDesignAlertsQuery(systemModel.name),
    );

    return {
      system,
      systemDesignAlerts,
    };
  };
